module.exports = __webpack_public_path__ + "img/icon-video-white.5536479a.svg";